import { storageKey } from "@/constants";
import { Store } from "./store";
import { createJSONStorage, persist } from "zustand/middleware";

export interface MailContactsPersistentStoreType {
  fromUserId?: string;
  userId?: string;
}
export const mailContactsPersistentStore =
  new Store<MailContactsPersistentStoreType>(
    persist(
      () => ({
        fromUserId: undefined,
        userId: undefined,
      }),
      {
        name: storageKey.WECHAT_CONTACTS_STORAGE, // name of the item in the storage (must be unique)
        storage: createJSONStorage(() => localStorage), // (optional) by default, 'localStorage' is used
      }
    ) as any
  );

export const mailContactsPersistentStoreActions = {
  selectContact(payload: { fromUserId?: string; userId?: string }) {
    mailContactsPersistentStore.set(payload);
  },
  reset() {
    localStorage.removeItem(storageKey.WECHAT_CONTACTS_STORAGE);
  },
};
